export default "__VITE_ASSET__B6l7hTNf__"